import axios from 'axios';

const spikkoApi = process.env.REACT_APP_SPIKKO_API;

export const spikkoAxios = axios.create({
    baseURL: spikkoApi
});


